export default __webpack_public_path__ + "static/media/references__karpis.dbfcedbc.jpg";